import { Button } from "./ui/button";
import { useLocation, useNavigate } from "react-router-dom";
import { Sparkles, Crown } from "lucide-react";

export const Header = ({ premium = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      // navigate home first, then scroll after mount
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/70 backdrop-blur-xl border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => scrollTo("hero")}
          className="flex items-center gap-2.5 group"
        >
          <span className="relative w-8 h-8 rounded-lg bg-[#CCFF00] flex items-center justify-center transition-transform group-hover:rotate-12">
            <Sparkles className="w-4 h-4 text-black" strokeWidth={2.5} />
          </span>
          <span className="flex flex-col items-start leading-none">
            <span className="font-display font-extrabold text-lg tracking-tight text-white">
              PromptKiste <span className="text-[#CCFF00]">AI</span>
            </span>
            <span className="hidden sm:block text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-medium mt-0.5">
              by Norrbyte
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-zinc-400">
          <button
            data-testid="nav-generator"
            onClick={() => scrollTo("generator")}
            className="hover:text-white transition-colors"
          >
            Generator
          </button>
          <button
            data-testid="nav-pricing"
            onClick={() => scrollTo("pricing")}
            className="hover:text-white transition-colors"
          >
            Preise
          </button>
          <button
            data-testid="nav-faq"
            onClick={() => scrollTo("faq")}
            className="hover:text-white transition-colors"
          >
            FAQ
          </button>
        </nav>

        <Button
          data-testid="header-cta"
          onClick={() => scrollTo("generator")}
          className="bg-[#CCFF00] hover:bg-[#B3E600] text-black font-semibold rounded-full px-5 h-10 transition-all hover:shadow-[0_0_24px_-4px_rgba(204,255,0,0.6)]"
        >
          {premium ? (
            <span
              data-testid="header-premium-badge"
              className="inline-flex items-center gap-1.5"
            >
              <Crown className="w-3.5 h-3.5" strokeWidth={2.5} />
              Premium aktiv
            </span>
          ) : (
            "Jetzt starten"
          )}
        </Button>
      </div>
    </header>
  );
};
